import Vue from 'vue';
import Component from 'vue-class-component';
import { SearchFieldModel } from '@/models/SearchField.model';
import { GridColumn } from '@/models/GridColumn.model';
import { Action, Getter, Mutation } from 'vuex-class';
import {
  ADP_MODE,
  CREATE_MASKIT_UPDATE_FILE,
  CREATE_ADP_UPDATE_FILE,
  CUBE,
  CUBE_DETAILS,
  CUBE_DETAILS_ERRORS,
  CUBE_SEARCH_OBJECT,
  FORM101_OFFICES_LIST,
  FORM101_UNITS_LIST,
  FORM101_UNITS_LIST_LOADING,
  GENERATE_COMPARE_RESULT_SEARCH_REPORT,
  GENERATE_CUBE_DETAILS_REPORT,
  GENERATE_GROUP_TYPE_EXPORT_EVENTS_REPORT,
  GET_CUBE_DETAILS,
  GET_CUBES_FORM101_DATA,
  GET_CUBES_FORM_101_CHANGES,
  GET_FORM101_OFFICES_LIST,
  GET_FORM101_UNITS_LIST,
  GET_ID_NUMBER_FIELDS,
  ID_NUMBER_FIELDS_DATA,
  MANAGER_LOADING,
  MARK_AS_IGNORE,
  MASKIT_MODE,
  SET_CUBE,
  SET_CUBE_DETAILS,
  SET_CUBE_DETAILS_ERRORS,
  SET_CUBE_SEARCH_OBJECT,
  SET_FORM101_UNITS_LIST,
  SET_FORM_101_CHANGES_NOTES_ERRORS,
  SET_MANAGER_LOADING,
  SET_MANAGER_MODE,
  SET_STATUS_DESC,
  UNDO_MARK_AS_IGNORE,
  UPDATE_IPT,
  UNDO_MARK_AS_UPDATE,
} from '@/types/managerForm.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Grid } from '@/models/Grid.model';
import { RowAction } from '@/models/RowAction.model';
import { Prop, Watch } from 'vue-property-decorator';
import MockData from '@/globals/mock';
import { CompareResultSearchRequestModel } from '@/models/manager/CompareResultSearchRequest.model';
import { eventsHub } from '@/main';
import { ClickColumn } from '@/models/ClickColumn.model';
import { SET_FORM_READ_ONLY_MODE, SET_OPEN_FORM_101_CHANGES_DIALOG } from '@/types/form.types';
import Form101ChangesModal from '@/components/modals/Form101Changes.modal.vue';
import { GetIdNumberFieldsResponseModel } from '@/models/manager/GetIdNumberFieldsResponse.model';
import { CubesInfoModel } from '@/models/manager/CubesInfo.model';
import { CubeFetchMode } from '@/models/manager/enums/Form101SearchType';
import { Form101SearchModel } from '@/models/Form101Search.model';
import { USER_DETAILS } from '@/types/authentication.types';
import { UserDetails } from '@/models/UserDetails.model';
import { CubeGroupTypes } from '@/views/dashboard/manager/cube-details/cube-group-types';
import Spinner from '@/components/loading/Spinner.vue';

@Component({
  components: {
    Form101ChangesModal,
    Spinner,
  },
})
export default class CubeDetailsComponent extends Vue {

  @Action(GET_FORM101_OFFICES_LIST, StoreNamespace.MANAGER) public getForm101OfficesList;
  @Action(GET_FORM101_UNITS_LIST, StoreNamespace.MANAGER) public getForm101UnitsList;
  @Action(GET_CUBE_DETAILS, StoreNamespace.MANAGER) public getCubeDetails;
  @Action(UPDATE_IPT, StoreNamespace.MANAGER) public updateIpt;
  @Action(MARK_AS_IGNORE, StoreNamespace.MANAGER) public markAsIgnore;
  @Action(UNDO_MARK_AS_IGNORE, StoreNamespace.MANAGER) public undoMarkAsIgnore;
  @Action(UNDO_MARK_AS_UPDATE, StoreNamespace.MANAGER) public undoMarkAsUpdate;
  @Action(CREATE_MASKIT_UPDATE_FILE, StoreNamespace.MANAGER) public createMaskitUpdateFile;
  @Action(CREATE_ADP_UPDATE_FILE, StoreNamespace.MANAGER) public createAdpUpdateFile;
  @Action(GENERATE_CUBE_DETAILS_REPORT, StoreNamespace.MANAGER) public generateCubeDetailsReport;
  @Action(GENERATE_COMPARE_RESULT_SEARCH_REPORT, StoreNamespace.MANAGER) public generateCompareResultSearchReport;
  @Action(GENERATE_GROUP_TYPE_EXPORT_EVENTS_REPORT, StoreNamespace.MANAGER) public generateGroupTypeExportEventsReport;
  @Action(GET_CUBES_FORM101_DATA, StoreNamespace.MANAGER) public getFormData;
  @Action(GET_CUBES_FORM_101_CHANGES, StoreNamespace.MANAGER) public getForm101Changes;
  @Action(GET_ID_NUMBER_FIELDS, StoreNamespace.MANAGER) public getIdNumberFields;

  @Mutation(SET_FORM101_UNITS_LIST, StoreNamespace.MANAGER) public setForm101UnitsList;
  @Mutation(SET_CUBE_DETAILS_ERRORS, StoreNamespace.MANAGER) public setCubeDetailsErrors;
  @Mutation(SET_FORM_READ_ONLY_MODE, StoreNamespace.FORM) public setFormReadOnlyMode;
  @Mutation(SET_OPEN_FORM_101_CHANGES_DIALOG, StoreNamespace.FORM) public setOpenForm101ChangesDialog;
  @Mutation(SET_FORM_101_CHANGES_NOTES_ERRORS, StoreNamespace.MANAGER) public setForm101ChangesNotesErrors;
  @Mutation(SET_MANAGER_MODE, StoreNamespace.MANAGER) public setManagerMode;
  @Mutation(SET_STATUS_DESC, StoreNamespace.MANAGER) public setStatusDesc;
  @Mutation(SET_CUBE, StoreNamespace.MANAGER) public setCube;
  @Mutation(SET_CUBE_SEARCH_OBJECT, StoreNamespace.MANAGER) public setCubeSearchObject;
  @Mutation(SET_CUBE_DETAILS, StoreNamespace.MANAGER) public setCubeDetails;
  @Mutation(SET_MANAGER_LOADING, StoreNamespace.MANAGER) public setManagerLoading;

  @Getter(USER_DETAILS, StoreNamespace.AUTHENTICATION) public userDetails!: UserDetails;
  @Getter(FORM101_OFFICES_LIST, StoreNamespace.MANAGER) public form101OfficesList!: any[];
  @Getter(FORM101_UNITS_LIST, StoreNamespace.MANAGER) public form101UnitsList!: any[];
  @Getter(CUBE_DETAILS, StoreNamespace.MANAGER) public resultData!: Grid;
  @Getter(CUBE_DETAILS_ERRORS, StoreNamespace.MANAGER) public searchErrors!: string[];
  @Getter(MANAGER_LOADING, StoreNamespace.MANAGER) public managerLoading!: boolean;
  @Getter(MASKIT_MODE, StoreNamespace.MANAGER) public maskitMode!: boolean;
  @Getter(ADP_MODE, StoreNamespace.MANAGER) public adpMode!: boolean;
  @Getter(ID_NUMBER_FIELDS_DATA, StoreNamespace.MANAGER) public idNumberFieldsData!: GetIdNumberFieldsResponseModel;
  @Getter(CUBE, StoreNamespace.MANAGER) public cube!: CubesInfoModel;
  @Getter(CUBE_SEARCH_OBJECT, StoreNamespace.MANAGER) public cubeSearchObject!: Form101SearchModel;
  @Getter(FORM101_UNITS_LIST_LOADING, StoreNamespace.MANAGER) public form101UnitsListLoading!: boolean;

  @Prop(String) public title!: string;
  @Prop(String) public groupType!: string;

  public cubeTitle!: string;
  public cubeGroupType!: string;

  public cubeFetchModeList: any[] = [];
  public cubeFetchMode: CubeFetchMode = CubeFetchMode.WAITING_FOR_UPDATE;

  public showSearch = true;
  public searchFields: SearchFieldModel[] = [];
  public columns: GridColumn[] = [];
  public rowMenuActions: RowAction[] = [];
  public formBaseClass = 'form-field form-field-large col-12 ';
  public firstClass = 'col-md-6 col-lg-3 col-xl-2';
  public secondClass = 'col-md-6 col-lg-3 col-xl-2';
  public officeNum: number = 0;
  public mockData: any = MockData;
  public searchObject: CompareResultSearchRequestModel = {} as CompareResultSearchRequestModel;
  public hideUnits: boolean = false;
  public limit = 50;
  public page = 0;

  public created() {
    this.cubeFetchModeList = Object.keys(CubeFetchMode).map((type) => {
      return { description: this.$t('CubeFetchMode.' + CubeFetchMode[type]), code: type };
    });
    this.setCubeSearchObject({ ...this.cubeSearchObject, cubeFetchMode: this.cubeFetchModeList[0].code });
    // this.searchObject.cubeFetchMode = this.cubeFetchModeList[0].code;
    this.cubeFetchMode = this.cubeFetchModeList[0].code;
    if (this.title) {
      this.setCube({ ...this.cube, title: this.title });
    }
  }

  public mounted() {
    // if (this.groupType === 'TAX_BENEFITS') {
    //   this.firstClass = 'col-md-6 col-lg-3 col-xl-3';
    // }
    if (this.groupType) {
      this.setCube({ ...this.cube, groupType: this.groupType });
      this.setCubeSearchObject({ ...this.cubeSearchObject, groupType: this.groupType });
    }

    this.setCubeDetailsErrors([]);
    this.getIdNumberFields();
    this.getForm101OfficesList();
    this.initRowMenuActions();
    this.onSearch();
    this.$on('menuActionClicked', this.menuActionClicked);
    window.onpopstate = (event) => {
      console.log('location: ' + document.location + ', state: ' + JSON.stringify(event.state));
      this.$emit('fetchSearch', this.cubeSearchObject);
    };
  }

  public menuActionClicked(action: RowAction, selectedRows: any[]) {
    switch (action.name) {
      case 'EXPORT_EXCEL':
        this.generateCubeDetailsReport(this.cubeSearchObject);
        break;
      case 'EXPORT_DATA':
        this.generateCompareResultSearchReport(this.cubeSearchObject);
        break;
      case 'EXPORT_EVENTS':
        this.generateGroupTypeExportEventsReport(this.cubeSearchObject);
        break;
      case 'UPDATE_DETAILS':
        if (!selectedRows.length) {
          this.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('form101.wizard.noSelectedRows'),
          });
          return;
        } else {
          this.updateIpt({
            selections: this.prepareSelection([...selectedRows]),
            groupType: this.cube.groupType,
            cubeFetchMode: this.cubeSearchObject.cubeFetchMode,
            searchObject: this.cubeSearchObject,
          });
        }
        break;
      case 'MARK_AS_IGNORE':
        if (!selectedRows.length) {
          this.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('form101.wizard.noSelectedRows'),
          });
          return;
        } else {
          this.markAsIgnore({
            selections: this.prepareSelection([...selectedRows]),
            groupType: this.cube.groupType,
            cubeFetchMode: this.cubeSearchObject.cubeFetchMode,
            searchObject: this.cubeSearchObject,
          });
        }
        break;
      case 'UNDO_MARK_AS_IGNORE':
        if (!selectedRows.length) {
          this.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('form101.wizard.noSelectedRows'),
          });
          return;
        } else {
          this.undoMarkAsIgnore({
            selections: this.prepareSelection([...selectedRows]),
            groupType: this.cube.groupType,
            cubeFetchMode: this.cubeSearchObject.cubeFetchMode,
            searchObject: this.cubeSearchObject,
          });
        }
        break;
      case 'UNDO_MARK_AS_UPDATE':
        if (!selectedRows.length) {
          this.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('form101.wizard.noSelectedRows'),
          });
          return;
        } else {
          this.undoMarkAsUpdate({
            selections: this.prepareSelection([...selectedRows]),
            groupType: this.cube.groupType,
            cubeFetchMode: this.cubeSearchObject.cubeFetchMode,
            searchObject: this.cubeSearchObject,
          });
        }
        break;
      case 'CREATE_MASKIT_UPDATE_FILE':
        if (!selectedRows.length) {
          this.$notify({
            group: 'frd',
            type: 'error',
            text: '' + eventsHub.$t('form101.wizard.noSelectedRows'),
          });
          return;
        } else {
          this.createMaskitUpdateFile({
            selections: this.prepareSelection( [...selectedRows]),
            groupType: this.cube.groupType,
            cubeFetchMode: this.cubeSearchObject.cubeFetchMode,
            searchObject: this.cubeSearchObject,
          });
        }
        break;
      case 'CREATE_ADP_UPDATE_FILE':
        if (!selectedRows.length){
          this.$notify({
            group:'frd',
            type:'error',
            text: '' + eventsHub.$t('form101.wizard.noSelectedRows'),
          });
          return;
        }else {
          this.createAdpUpdateFile({
            selections: this.prepareSelection([...selectedRows]),
            groupType: this.cube.groupType,
            cubeFetchMode:this.cubeSearchObject.cubeFetchMode,
            searchObject: this.cubeSearchObject,
          });
        }
    }
    this.setManagerLoading(true);
    this.page = 0;
  }

  public selectOffice(item: any) {
    this.showSearch = false;
    if (item) {
      this.officeNum = item;
      this.searchObject.orgUnitFrom = null;
      this.searchObject.orgUnitTo = null;
      this.getForm101UnitsList(item);
    }
    this.showSearch = true;
  }

  public onClear() {
    this.setCubeDetailsErrors([]);
    this.setCubeDetails({} as Grid);
    this.showSearch = false;
    if (this.cube.groupType) {
      this.setCubeSearchObject({
        cubeFetchMode: this.cubeFetchModeList[0].code,
        groupType: this.cube.groupType,
      } as Form101SearchModel);
    }
    this.updateFormsSearchObject(null, 'officeNum');
    this.setForm101UnitsList([]);
    setTimeout(() => this.showSearch = true, 0);
  }

  public onSearch() {
    // this.cubeFetchMode = this.searchObject.cubeFetchMode;
    this.page = 0;
    this.initRowMenuActions();
    if (this.cube.groupType) {
      // searchObject.groupType = this.cube.groupType;
      // this.searchObject = ({ ...this.searchObject, ...searchObject });
      this.getCubeDetails(
        this.cubeSearchObject,
      );
    }
  }


  public onTdClicked(item: any, row: any) {
    switch (row.clickEvent) {
      case 'CHANGES':
        this.onForm101ChangesClicked(item);
        break;
      case 'VIEW':
        this.onForm101ViewClicked(item);
        break;
    }
  }

  public onPageChange(page: number) {
    this.page = page - 1;
    return this.filtered!.results.slice(page - 1, this.limit);
  }

  public onRecordsPerPageChanged(records: number) {
    this.limit = records;
    this.page = 0;
    return this.filtered!.results.slice(0, this.limit);
  }

  private onForm101ViewClicked(item: any) {
    this.setManagerMode(true);
    this.setFormReadOnlyMode(true);
    this.setStatusDesc(item.formStatusDesc);
    this.getFormData({
      formId: item.formId,
      idNum: item.employeeId.idNum,
      officeNum: item.employeeId.officeNum,
      positionNum: item.employeeId.positionNum,
      routeToWizard: true,
    });
  }

  private onForm101ChangesClicked(item: any) {
    this.setForm101ChangesNotesErrors([]);
    this.getFormData({
      formId: item.formId,
      officeNum: item.employeeId.officeNum,
      idNum: item.employeeId.idNum,
      positionNum: item.employeeId.positionNum,
      routeToWizard: false,
    });
    this.getForm101Changes({
      formId: item.formId,
      officeNum: item.employeeId.officeNum,
      idNum: item.employeeId.idNum,
      positionNum: item.employeeId.positionNum,
      openForm101ChangesDialog: true,
    });
  }


  private initColumns() {
    if (this.idNumberFieldsData.idNumberField1) {
      const field1 = this.idNumberFieldsData.idNumberField1.split('.');
      this.columns.push({
        property: field1[0],
        innerProperty: field1[1],
        header: this.idNumberFieldsData.idNumberTitle1,
        hideSorting: true,
      } as GridColumn);
    }
    if (this.idNumberFieldsData.idNumberField2) {
      this.columns.push({
        property: this.idNumberFieldsData.idNumberField2,
        header: this.idNumberFieldsData.idNumberTitle2,
        hideSorting: true,
      } as GridColumn);
    }
    if (this.idNumberFieldsData.idNumberField3) {
      this.columns.push({
        property: this.idNumberFieldsData.idNumberField3,
        header: this.idNumberFieldsData.idNumberTitle3,
        hideSorting: true,
      } as GridColumn);
    }
    this.columns.push({
      property: 'fullName',
      header: 'employees_list.fullName',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'officeName',
      header: 'employees_list.officeNum',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'mainDeptNameAndCode',
      header: 'employees_list.orgUnitName',
      hideSorting: true,
    } as GridColumn);
    if (this.cube.groupType === CubeGroupTypes.RELATIVES || this.cube.groupType === CubeGroupTypes.TAX_BENEFITS) {
      this.columns.push({
        property: 'description',
        header: `employees_list.type_${this.cube.groupType}`,
        hideSorting: true,
      } as GridColumn);
    }
    this.columns.push({
      property: 'errorMessage',
      header: 'employees_list.errorMessage',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      clickEvent: 'CHANGES',
      faIcon: 'exchange',
      faIconType: 'fal',
      header: 'employees_list.changes',
      hideSorting: true,
    } as ClickColumn);
    this.columns.push({
      clickEvent: 'VIEW',
      faIcon: 'eye',
      faIconType: 'fal',
      header: 'employees_list.view',
      hideSorting: true,
    } as ClickColumn);
  }

  private initRowMenuActions() {
    this.rowMenuActions = [];
    this.rowMenuActions.push({
      name: 'EXPORT_EXCEL',
      faIconType: 'fal',
      faIconName: 'file-excel',
      event: 'EXPORT_EXCEL',
    } as RowAction);
    this.rowMenuActions.push({
      name: 'EXPORT_DATA',
      faIconType: 'fal',
      faIconName: 'file-excel',
      event: 'EXPORT_DATA',
    } as RowAction);
    this.rowMenuActions.push({
      name: 'EXPORT_EVENTS',
      faIconType: 'fal',
      faIconName: 'file-excel',
      event: 'EXPORT_EVENTS',
    } as RowAction);
    if (!this.maskitMode && this.cubeSearchObject.cubeFetchMode === CubeFetchMode.WAITING_FOR_UPDATE &&
      !this.adpMode) {
      // if (!this.maskitMode) {
      this.rowMenuActions.push({
        name: 'UPDATE_DETAILS',
        faIconType: 'fal',
        faIconName: 'check-circle',
        event: 'UPDATE_DETAILS',
      } as RowAction);
    }
    if (this.adpMode && this.cubeSearchObject.cubeFetchMode === CubeFetchMode.DONE) {
      this.rowMenuActions.push({
        name: 'UNDO_MARK_AS_UPDATE',
        faIcon: 'fal',
        faIconName: 'check-circle',
        event: 'UNDO_MARK_AS_UPDATE',
      } as RowAction);
    }
    if (this.cubeSearchObject.cubeFetchMode === CubeFetchMode.WAITING_FOR_UPDATE) {
      this.rowMenuActions.push({
        name: 'MARK_AS_IGNORE',
        faIconType: 'fal',
        faIconName: 'times-circle',
        event: 'MARK_AS_IGNORE',
      } as RowAction);
    }
    // if (this.fetchHiddenMode) { // fetch . something
    if (this.cubeSearchObject.cubeFetchMode === CubeFetchMode.IGNORED) {
      this.rowMenuActions.push({
        name: 'UNDO_MARK_AS_IGNORE',
        faIconType: 'fal',
        faIconName: 'times-circle',
        event: 'UNDO_MARK_AS_IGNORE',
      } as RowAction);
    }
    if (this.maskitMode && this.cubeSearchObject.cubeFetchMode === CubeFetchMode.WAITING_FOR_UPDATE &&
      !this.adpMode) {
      this.rowMenuActions.push({
        name: 'CREATE_MASKIT_UPDATE_FILE',
        faIconType: 'fal',
        faIconName: 'check-circle',
        event: 'CREATE_MASKIT_UPDATE_FILE',
      } as RowAction);
    }
    if (this.adpMode && this.cubeSearchObject.cubeFetchMode ===
      CubeFetchMode.WAITING_FOR_UPDATE &&
      (this.cube.groupType === CubeGroupTypes.RELATIVES ||
        this.cube.groupType === CubeGroupTypes.TAX_BENEFITS ||
        this.cube.groupType === CubeGroupTypes.TAX_BENEFITS_ADDITIONAL_INCOME)) {
      this.rowMenuActions.push({
        name: 'CREATE_ADP_UPDATE_FILE',
        faIconType: 'fal',
        faIconName: 'check-circle',
        event: 'CREATE_ADP_UPDATE_FILE',
      } as RowAction);
    }
  }

  private updateFormsSearchObject(newVal: any, property: string, clear?: boolean) {
    if (property === 'officeNum' && (newVal || newVal === null)) {
      this.hideUnits = true;
      this.setForm101UnitsList([]);
      this.updateFormsSearchObject(null, 'orgUnitFrom');
      this.updateFormsSearchObject(null, 'orgUnitTo');
      if (newVal !== null) {
        this.getForm101UnitsList(newVal);
      }
      setTimeout(() => this.hideUnits = false, 0);
    }
    this.setCubeSearchObject({ ...this.cubeSearchObject, [property]: newVal });
    // this.searchObject = ({ ...this. searchObject, [property]: newVal });
  }

  private updateCubeFetchMode(newVal: any, property: string) {
    this.cubeFetchMode = {} = newVal; // this.cubeFetchModeList[newVal].code;
    // this.searchObject = ({ ...this.searchObject, [property]: newVal });
    this.setCubeSearchObject({ ...this.cubeSearchObject, [property]: newVal });
  }

  private prepareSelection(selectedRows: any[]) {
    return selectedRows.map(({ employeeId, grpSubKey}) => {
      return {
        employeeId: {
        officeNum: employeeId?.officeNum,
        idNum: employeeId?.idNum,
        positionNum: employeeId?.positionNum,
      },
        grpSubKey
      };
    });
  }

  // private beforeDestroy(): void {
  //   this.setCubeDetails({} as Grid);
  // }

  get filtered(): any {
    if (this.resultData.results) {
      const start = this.page * this.limit;
      const end = start + this.limit;
      return { ...this.resultData, results: this.resultData.results.slice(start, end) };
    }
  }

  @Watch('idNumberFieldsData')
  private onIdNumberFieldsDataChanged() {
    this.initColumns();
  }

}

